import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IActTeamActions, IThunkGetAllActTeamsAvailable } from '../types';

const onGetAllActTeamsAvailable: IThunkGetAllActTeamsAvailable = thunk(
  async ({ setAllActTeams }: Actions<IActTeamActions>, { clinicId }) => {
    const { data } = await api.actTeam.getActTeamsAvailable(clinicId);
    setAllActTeams(data);
  },
);

export default onGetAllActTeamsAvailable;
